module.exports = __webpack_public_path__ + "img/L_319_0.932a57a4.png";